import React from 'react';
import { IoChevronDownOutline } from 'react-icons/io5';
import '../styles/DropdownSelector.scss';

interface DropdownSelectorProps {
  label: string;
  options: string[] | Record<string, string>;
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

const DropdownSelector: React.FC<DropdownSelectorProps> = ({ label, options, value, onChange, disabled = false }) => {
  const getDisplayValue = () => {
    if (Array.isArray(options)) {
      return value;
    } else {
      return options[value] || value;
    }
  };

  return (
    <div className="dropdownSelector">
      <div className="dropdownContainer">
        <div className={`dropdownField ${disabled ? 'disabled' : ''}`}>
          <span className="dropdownText">{getDisplayValue()}</span>
          <div className="dropdownIcon">
            <IoChevronDownOutline />
          </div>
        </div>
        <select
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="dropdownSelect"
          id={label}
          title={label}
          disabled={disabled}
        >
          {
            Array.isArray(options) ?
            (
              options.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))
            ) : (
              Object.entries(options)
                .sort(([keyA, labelA], [keyB, labelB]) => {
                  if (keyA === '') return -1;
                  if (keyB === '') return 1;
                  return labelA.localeCompare(labelB, 'hu');
                })
                .map(([key, val]) => (
                  <option key={key} value={key}>
                    {val}
                  </option>
                ))
            )
          }
        </select>
      </div>
    </div>
  );
};

export default DropdownSelector;
